import jwt_decode from 'jwt-decode';
import { decode as decodeHtml } from 'html-entities';

var alkem_token = localStorage.getItem('alkem_token');
export function getUserType(login_token) {
	try {
		let token = jwt_decode(login_token);

		if (token.type === 'E') {
			return 'Employee';
		} else if (token.type === 'D') {
			return 'Distributor';
		}
	} catch (error) {
		//localStorage.clear();
		window.location.href = '';
	}
}

export function getUserEmail(login_token) {
	try {
		let token = jwt_decode(login_token);
		// console.log('token');
		return token.email;
	} catch (error) {
		window.location.href = '';
	}
}

export function getDivType(login_token) {
	try {
		let token = jwt_decode(login_token);

		if (token.div_type === 'B') {
			return 'Both';
		} else if (token.div_type === 'G') {
			return 'G';
		} else if (token.div_type === 'E') {
			return 'E';
		} else {
			return 'E';
		}
	} catch (error) {
		//localStorage.clear();
		window.location.href = '';
	}
}

export function getMultipleCfa(login_token) {
	try {
		let token = jwt_decode(login_token);
		return token.multiple_cfa_code;
	} catch (error) {
		//localStorage.clear();
		window.location.href = '';
	}
}

export function getTypeofUser() {
	try {
		let token = jwt_decode(alkem_token);
		if (token.type === 'E') {
			return 'Employee';
		} else if (token.type === 'D') {
			return 'Distributor';
		}
	} catch (error) {
		//localStorage.clear();
		window.location.href = '';
	}
}

// to display "Longsting" to "Long..""
export function trimString(length, string, prependText = '...') {
	return string?.length > length ? string.substring(0, length) + prependText : string;
}

export const minCharacter = (text, min = 1) => {
	return text.length > min - 1;
};

export const getBgColorForStatus = (status_code) => {
	return status_code === 6 || status_code === 10
		? 'bg-warning'
		: status_code === 2 || status_code === 1
			? 'bg-success'
			: status_code === 5 || status_code === 3 || status_code === 11
				? 'bg-danger'
				: 'bg-info';
};

export const spinnerStyle = {
	width: '1.5rem',
	height: '1.5rem',
	marginLeft: '0.5rem',
};
export const onlyNumber = (value) => {
	value = value.replace('+', '').replace('-', '');
	value = value ? value : '0';
	if (value < 0) value = '0';
	else if (value?.indexOf('.') > -1) {
		value = value.split('.')?.[0];
	} else if (value[0] === '0') {
		value = value.slice(1);
	}
	return value ? value : '0';
};

export const getFreeQty = (min_qty, scheme_qty, qty) => {
	return scheme_qty && min_qty && Number(min_qty) + scheme_qty <= qty
		? Math.floor((qty * scheme_qty) / (Number(min_qty) + scheme_qty))
		: 0;
};

let timer;
export function debounce(func, timeout = 900) {
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(this, args);
		}, timeout);
	};
}

export const htmlDecode = (string) => {
	return decodeHtml(string, { level: 'html5' });
};

export const htmlDecodeText = (string) => {
	return decodeHtml(string);
};

export const getHeightWidth = (file) => {
	return new Promise((resolve, reject) => {
		var reader = new FileReader();
		var height;
		var width;
		reader.readAsDataURL(file);
		reader.onload = function (e) {
			var image = new Image();
			image.src = e.target.result;
			image.onload = function () {
				height = this.height;
				width = this.width;

				resolve({
					height: height,
					width: width,
				});
			};
		};
	});
};

export const arrangeProductSuggestions = (arr) => {
	const dashProductCodeObjects = arr.filter((item) => item.product_code === '-');
	const otherProductCodeObjects = arr.filter((item) => item.product_code !== '-');
	return [...dashProductCodeObjects, ...otherProductCodeObjects];
};

export const FILE_VALIDATION_TYPE_ERROR_MASSAGE = `The file does not match height and width validations.`;

export const validateSchemeAdminEnable = (data) => {
	let result = { index: -1, totalQty: null, product_name: undefined, product_code: undefined };
	data.some((item, index) => {
		const { scheme_admin_enable, min_qty, scheme_qty, product_code, product_name } = item.sub_data;
		const { total_qty } = item;
		const totalQty = parseFloat(min_qty) + parseFloat(scheme_qty);
		if (scheme_admin_enable === 1 && total_qty >= 1 && total_qty < totalQty) {
			// console.log('Scheme validation failed:', { product_name, uploaded_product, product_code, sub_data: item.sub_data });
			result = { index, totalQty, product_name, product_code };
			return true; // Exit the loop early when condition is met
		}

		return false;
	});
	return result;
};

export const validateConfirmOrderSchemeAdminEnable = (data) => {
	let result = { status: true, productCode: '', productName: '', totalQuantity: 0 };

	data.some((item) => {
		const { scheme_admin_enable, min_qty, scheme_qty, quantity_ordered, product_code, product_name } = item;

		const quantityOrder = parseFloat(quantity_ordered);
		const totalQty = parseFloat(min_qty) + parseFloat(scheme_qty);

		if (scheme_admin_enable === 1 && quantityOrder >= 1 && quantityOrder < totalQty) {
			result = {
				status: false,
				productCode: product_code,
				productName: product_name,
				totalQuantity: totalQty,
			};
			return true; // Exit loop early
		}

		return false; // Continue the loop
	});

	return result;
};

export function calculateSchemeQuantity(inputQty, schemeData) {

	const minQty = parseInt(schemeData.min_qty, 10);
	const schemeQty = parseInt(schemeData.scheme_qty, 10);

	if (!minQty && !schemeQty) {
		const shrink = parseInt(schemeData.shrink, 10);
		const mono = parseInt(schemeData.mono, 10);
		const fallbackBase = shrink || mono;

		if (fallbackBase) {
			return {
				quantity: Math.ceil(inputQty / fallbackBase) * fallbackBase,
				freeQty: 0,
			};
		}
	}

	const base = minQty + schemeQty
	if (schemeData.scheme_admin_enable === 1 && schemeData.compul_scheme_admin_enable === 1) {

		const freeUnits = Math.floor((inputQty * schemeQty) / base);

		return {
			quantity: inputQty > base ? inputQty : base,
			freeQty: inputQty > base ? freeUnits : schemeQty
		}
	} else {
		// Find the nearest multiple of min_qty that is >= numericValue
		const closestMultiple = Math.ceil(inputQty / base) * base;

		// Calculate the free quantity based on the number of offers
		const free_qty = Math.ceil(inputQty / base) * schemeQty;

		// Adjust numericValue to the total valid offer quantity
		// const adjustedValue = closestMultiple + free_qty;

		return {
			quantity: closestMultiple,
			freeQty: free_qty,
		};
	}
	// const minQty = parseInt(schemeData.min_qty, 10);
	// const schemeQty = parseInt(schemeData.scheme_qty, 10);
	// const baseLimit = minQty + schemeQty;
	// const blockNumber = Math.ceil(inputQty / baseLimit);
	// const schemeValue = baseLimit * blockNumber;
	// const freeQty =
	// 	schemeQty && minQty && minQty + schemeQty <= schemeValue
	// 		? Math.floor((schemeValue * schemeQty) / (minQty + schemeQty))
	// 		: 0;

	// return {
	// 	quantity: schemeValue,
	// 	freeQty: freeQty,
	// };
}

export function calculateSchemeQuantitySubtraction(inputQty, schemeData) {
	const minQty = parseInt(schemeData.min_qty, 10);
	const schemeQty = parseInt(schemeData.scheme_qty, 10);

	if (!minQty && !schemeQty) {
		const shrink = parseInt(schemeData.shrink, 10);
		const mono = parseInt(schemeData.mono, 10);
		const fallbackBase = shrink || mono;

		if (fallbackBase) {
			return {
				quantity: Math.ceil(inputQty / fallbackBase) * fallbackBase,
				freeQty: 0,
			};
		}
	}

	const base = minQty + schemeQty
	if (schemeData.scheme_admin_enable === 1 && schemeData.compul_scheme_admin_enable === 1) {
		const freeUnits = Math.floor((inputQty * schemeQty) / base);

		return {
			quantity: inputQty > base ? inputQty : base,
			freeQty: inputQty > base ? freeUnits : schemeQty
		}
	} else {
		// Find the nearest multiple of min_qty that is >= numericValue
		const closestMultiple = Math.ceil(inputQty / base) * base;

		// Calculate the free quantity based on the number of offers
		const free_qty = Math.ceil(inputQty / base) * schemeQty;

		// Adjust numericValue to the total valid offer quantity
		// const adjustedValue = closestMultiple + free_qty;

		return {
			quantity: closestMultiple,
			freeQty: free_qty,
		};
	}

	// const minQty = parseInt(schemeData.min_qty, 10);
	// const schemeQty = parseInt(schemeData.scheme_qty, 10);
	// const baseLimit = minQty + schemeQty;
	// if (inputQty <= baseLimit) {
	// 	return { quantity: 0, freeQty: 0 };
	// }
	// const tier = Math.ceil(inputQty / baseLimit) - 1;
	// const schemeValue = tier * baseLimit;
	// const freeQty = tier * schemeQty;

	// return {
	// 	quantity: schemeValue,
	// 	freeQty: freeQty,
	// };
}
